import React from "react";
import {
  Routes as RouterRoutes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";

const Routes = () => {
  const { token, isAuthenticated, isNew } = useSelector((state) => state.auth);
  const location = useLocation();

  // Función para transformar un path a una expresión regular
  const pathToRegex = (path) => {
    return new RegExp("^" + path.replace(/:[^/]+/g, "[^/]+") + "$");
  };

  // Verificamos si la ruta actual es pública
  const isPublicRoute = publicRoutes.some((route) => {
    const pattern = pathToRegex(route.path);
    return pattern.test(location.pathname);
  });

  // Si es una ruta pública, se renderizan las rutas públicas sin validación adicional
  if (isPublicRoute) {
    return (
      <RouterRoutes>
        <Route path="/" element={<PublicRoute />}>
          {publicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          ))}
        </Route>
      </RouterRoutes>
    );
  }

  // Si no hay token y no es una ruta pública, redirigir al login
  if (!token && !isPublicRoute) {
    return <Navigate to="/auth/login" replace />;
  }

  // Con base en el tipo de usuario se define el índice para el redireccionamiento inicial
  let indexOne = 0;

  if ((isNew !== 0)) {
    indexOne = 1;
  } else if ((isNew === 0)) {
    indexOne = 2;
  }

  const initialRedirectPath = `${AUTHENTICATED_ENTRY[indexOne]}/`.replace(/\/\/+/g, "/");

  // Si el usuario está autenticado y se encuentra en la página de login, se redirige a la ruta inicial
  if (isAuthenticated && location.pathname === "/auth/login") {
    return <Navigate to={initialRedirectPath} replace />;
  }

  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={
            location.pathname === "/" ? (
              <Navigate replace to={initialRedirectPath} />
            ) : null
          }
        />
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <AppRoute
                routeKey={route.key}
                component={route.component}
                {...route.meta}
              />
            }
          />
        ))}
        <Route
          path="*"
          element={<Navigate to="auth/no-access-permission" replace />}
        />
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
